<section class="cm-section">
  <div class="cm-container">
    <h1 class="cm-section-heading" [innerHTML]="'currencies.title' | translate"></h1>
    <h2>{{ 'currencies.table-title' | translate }}</h2>

    <app-currencies-table></app-currencies-table>
    <div class="mt-10">
      <app-wp-page-content [showHeadline]="false" page="cryptocurrency-prices"></app-wp-page-content>
    </div>
  </div>
</section>
